import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { store } from './redux/store'
import { CookiesProvider } from 'react-cookie'
import { ThemeProvider } from '@mui/material'
import AuthMiddleware from './helpers/AuthMiddleware'
import { theme } from './theme'
import { App } from './App'
import reportWebVitals from './reportWebVitals'
import MsalProviderCustom from './components/MsalProviderCustom'
// @ts-ignore
import './index.css'
// Fontsource can be configured to load specific subsets, weights, and styles.
// @ts-ignore
import '@fontsource/roboto/300.css'
// @ts-ignore
import '@fontsource/roboto/400.css'
// @ts-ignore
import '@fontsource/roboto/500.css'
// @ts-ignore
import '@fontsource/roboto/700.css'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <CookiesProvider>
            <MsalProviderCustom>
              <AuthMiddleware>
                <App />
              </AuthMiddleware>
            </MsalProviderCustom>
          </CookiesProvider>
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
reportWebVitals()
